import React from 'react';
import './styles/_calendar.scss';
import PropTypes from 'prop-types';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import esLocale from '@fullcalendar/core/locales/es-us';
import PageLayout from 'src/common/components/PageLayout';
import interactionPlugin from '@fullcalendar/interaction';

const customView = (eventInfo) => {
	return (
		<div
			className="calendar-content"
			style={{
				backgroundColor:
					eventInfo?.view?.type === 'listMonth'
						? 'transparent'
						: eventInfo?.event?.extendedProps?.eventColor,
			}}
		>
			<p
				className={
					eventInfo?.view?.type === 'listMonth'
						? 'text-dark'
						: 'font-size-sm text-wrap'
				}
			>
				{eventInfo?.event?.title}
			</p>
		</div>
	);
};

const Calendar = ({
	data = [],
	eventClick = () => {},
	calendarPlugins = [dayGridPlugin, listPlugin, interactionPlugin],
	initialView = 'dayGridMonth',
	calendarViews = 'dayGridMonth,listMonth',
	title = '',
	dateClick = () => {},
	datesSet = () => {},
}) => {
	return (
		<PageLayout className="bg-white" title={title}>
			<FullCalendar
				events={data}
				eventClick={eventClick}
				locale={esLocale}
				plugins={calendarPlugins}
				initialView={initialView}
				headerToolbar={{
					right: 'today prev,next',
					center: 'title',
					left: calendarViews,
				}}
				eventContent={customView}
				dateClick={dateClick}
				datesSet={datesSet}
			/>
		</PageLayout>
	);
};

Calendar.propTypes = {
	calendarPlugins: PropTypes.array,
	calendarViews: PropTypes.string,
	data: PropTypes.array.isRequired,
	eventClick: PropTypes.func,
	initialView: PropTypes.string,
	title: PropTypes.string,
	dateClick: PropTypes.func,
};

export default Calendar;
